<div
  #host
  class="editable-text"
  (click)="clickText($event)"
  [style.cursor]="editDisabled ? 'pointer' : 'text'"
  [ngClass]="{
    'size-m': size == 'm',
    'size-l': size == 'l',
  }"
>
  <div
    class="text-view no-select-x"
    *ngIf="!editMode"
    [ngClass]="{
      'size-s': size == 's',
      'size-m': size == 'm',
      'size-l': size == 'l',
    }"
    [style.color]="dark ? '#000' : '#fff'"
  >
    {{ text }}
  </div>

  <input
    #input
    *ngIf="editMode"
    [(ngModel)]="text"
    style="position: relative; left: -3px"
    [ngClass]="{
      'size-m-input': size == 'm',
      'size-l-input': size == 'l',
    }"
    [style.color]="dark ? '#000' : '#fff'"
    (keydown)="change($event)"
    (keyup)="$event.stopPropagation(); keyUp($event)"
    [style.width.px]="inputWidth"
  />

  <!-- <nw-floating [top]="-18" [left]="-2" *ngIf="editMode">
    <input #input [(ngModel)]="text" (keydown)="change($event)" />
  </nw-floating> -->
</div>
